import { Stack } from '@mui/material';

import { WindDataItemFormattedWithUnits } from '@/api/historicalData';
import { Line } from '@/charts';
import { getYValue } from '@/charts/helpers';
import { LineIcon } from '@/components/data/ColorIcon';
import { Datum, unit, unitType } from '@/components/data/Datum';
import { DirectionDatum } from '@/components/data/DirectionDatum';
import { DataDetailDatum } from '@/components/spotter/historicalDataTab/datumDetail/DataDetailPanel';

export type WindDatumDetailProps = {
    datum: WindDataItemFormattedWithUnits;
    dataset: WindDataItemFormattedWithUnits[];
    line: Line<WindDataItemFormattedWithUnits> & WindLineConfig;
};

export type WindLineConfig = {
    valueKey: string;
    directionKey: string;
    unitTypeKey: string;
    unitKey: string;
};

export const WindDatumDetail = ({ datum, line }: WindDatumDetailProps) => {
    return (
        <Stack justifyItems="stretch">
            <DataDetailDatum label="Wind speed" icon={<LineIcon dot color={line.color.line} />}>
                <Datum
                    value={getYValue(datum, line.valueKey)}
                    type={unitType(line, datum)}
                    sourceUnit={unit(line, datum)}
                />
            </DataDetailDatum>
            <DataDetailDatum label="Direction">
                <DirectionDatum
                    iconSx={{ fontSize: '1em' }}
                    heading={getYValue(datum, line.directionKey)}
                    type="source"
                    unit="deg"
                />
            </DataDetailDatum>
        </Stack>
    );
};
